export default Symbol('container');



// WEBPACK FOOTER //
// ./src/js/util/accordion.js